import { formatUIDate } from 'utils/helpers'
import { DailyReportTableItem } from '../interfaces'
import { getDailyReportName } from '../common/helpers'

export const toTableRowItems = items =>
  items.map(item => ({
    id: item.id,
    pvNumber: item.pvNumber ?? '',
    storeName: item.storeName ?? '',
    date: formatUIDate(item.date),
    categoryName: item.wasteCategoryName ?? '',
    carrierName: item.carrierName ?? '',
    companyName: item.companyName ?? '',
    dailyReports: item.dailyReports
      ? item.dailyReports.map((report: DailyReportTableItem) => getDailyReportName(report))
      : '',
    totalArticles: item.totalArticles ?? 0,
    totalCalculatedWeight: item.totalCalculatedWeight ?? 0,
    measuredWeight: item.measuredWeight ?? '',
    documentNo: item.documentNo ?? 0,
    isHandedOver: item.isHandedOver ?? false,
  }))
